import { getToken } from '@api/config';
import { createHeaders, defaultHttpRequestHeader } from '@api/httpHeaderConfig';
import { getAllBrowserInfo } from '@utils/browser.info.util';
import { AuthResponse, updateUserStatusRequest, userStatusResponse } from 'custom';
import { axiosFetchHandler } from './configs/fetchWrapper';

export enum LoginTypes {
  'TOKEN' = 'token',
  'LINK' = 'link',
  'SSO' = 'sso',
}

export const getIpAddress = async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');

    if (response.ok) {
      const ipAddress = await response.json();

      return ipAddress.ip;
    }
  } catch (error) {
    return null;
  }

  return null;
};

export const loginUser = async (body: any) => {
  const requestOptions = {
    method: 'POST',
    headers: defaultHttpRequestHeader,
    body: JSON.stringify(body),
  };

  return fetch(`${process.env.REACT_APP_API_URL}/auth/trigger-login-email`, requestOptions);
};

export const getCurrentUserStatus = async () => {
  const response = await axiosFetchHandler(`${process.env.REACT_APP_API_URL}/user-status`, {
    headers: createHeaders({ Authorization: `Bearer ${getToken()}` }),
  });

  if (!response.ok) {
    throw new Error('Failed to get user Status data');
  }

  const result: userStatusResponse = await response.json();

  return result;
};

export const updateCurrentUserStatus = async (userId: number, data: updateUserStatusRequest) => {
  const requestOptions = {
    method: 'PUT',
    headers: createHeaders({ Authorization: `Bearer ${getToken()}` }),
    body: JSON.stringify(data),
  };

  const userData = await axiosFetchHandler(
    `${process.env.REACT_APP_API_URL}/setUserStatus/${userId}`,
    requestOptions,
  );

  if (!userData.ok) {
    throw new Error('Failed to update user Status data');
  }

  return (await userData.json()) as userStatusResponse;
};

export const verifyInviteTokenRequest = async (body: any) => {
  const ipAddress = await getIpAddress();
  const browserInfo = await getAllBrowserInfo();

  const os = navigator.userAgentData?.platform;
  // TODO: CHECK THIS BEFORE MERGE (LAST INDEX)

  const data = { ...body, ipAddress, os: browserInfo?.os, brand: browserInfo?.brand };

  const requestOptions = {
    method: 'POST',
    headers: createHeaders({ Authorization: `Bearer ${getToken()}` }),
    body: JSON.stringify(data),
  };

  const userData = await axiosFetchHandler(
    `${process.env.REACT_APP_API_URL}/auth/login`,
    requestOptions,
  );

  const responseData = (await userData.json()) as AuthResponse & {
    message?: string;
    validation?: Record<string, string>;
  };

  if (!userData.ok) {
    const validationMessage =
      responseData?.validation && typeof responseData.validation === 'object'
        ? Object.values(responseData.validation).find((value) => typeof value === 'string')
        : null;

    throw new Error(validationMessage || responseData?.message || 'Login failed');
  }

  return responseData;
};

export const confirmUserLogin = async (body: any) => {
  const requestOptions = {
    method: 'POST',
    headers: createHeaders({ Authorization: `Bearer ${getToken()}` }),
    body: JSON.stringify(body),
  };

  return axiosFetchHandler(
    `${process.env.REACT_APP_API_URL}/auth/confirm-user-login`,
    requestOptions,
  );
};
